import React, { useEffect, useState, useRef } from 'react';
import PageTitle from '../../../widgets/PageTitle/PageTitle';
import './YDCAwardsPrizes.scss';
import { Row, Col } from 'reactstrap';
import { parseSanitizedHTML } from '../../../utils/Helper';

const YDCAwardsPrizes = (props) => {
  const { awardsPrizes, title } = props;

  return (
    <>
      <PageTitle title={title} />
      <div style={{ backgroundColor: 'rgb(211, 211, 211)', padding: '20px' }}>
        {awardsPrizes && parseSanitizedHTML(awardsPrizes.awards_prizes_description)}
      </div>
    </>
  );
};

export default YDCAwardsPrizes;
